import type { TranslationDict } from "./en.js";

const zh_HK: TranslationDict = {
  // Navbar
  "nav.myVideos": "我的影片",
  "nav.users": "用戶",
  "nav.upload": "上傳",
  "nav.profile": "個人檔案",
  "nav.signOut": "登出",
  "nav.signIn": "登入",

  // Common
  "common.loading": "載入中...",
  "common.cancel": "取消",
  "common.delete": "刪除",
  "common.save": "儲存",
  "common.saving": "儲存中...",
  "common.deleting": "刪除中...",
  "common.adding": "新增中...",
  "common.unknown": "未知",
  "common.you": "你",
  "common.audio": "音訊",
  "common.default": "預設",

  // Theme
  "theme.system": "系統",
  "theme.light": "淺色",
  "theme.dark": "深色",

  // Language
  "language.en": "English",
  "language.zh_HK": "繁體中文",
  "language.zh_CN": "简体中文",

  // Status
  "status.NEW": "新增",
  "status.QUEUED": "排隊中",
  "status.PROCESSING": "處理中",
  "status.READY": "就緒",
  "status.FAILED": "失敗",

  // Visibility
  "visibility.public": "公開",
  "visibility.private": "私人",
  "visibility.protected": "受保護",

  // Monetization
  "monetization.free": "免費",
  "monetization.sub": "訂閱",
  "monetization.svod": "SVOD",
  "monetization.tvod": "TVOD",
  "monetization.ads": "廣告",

  // Time
  "time.justNow": "剛剛",
  "time.minuteAgo": "{n} 分鐘前",
  "time.minutesAgo": "{n} 分鐘前",
  "time.hourAgo": "{n} 小時前",
  "time.hoursAgo": "{n} 小時前",
  "time.dayAgo": "{n} 日前",
  "time.daysAgo": "{n} 日前",
  "time.monthAgo": "{n} 個月前",
  "time.monthsAgo": "{n} 個月前",
  "time.yearAgo": "{n} 年前",
  "time.yearsAgo": "{n} 年前",

  // Login page
  "login.title": "登入",
  "login.email": "電郵",
  "login.password": "密碼",
  "login.submit": "登入",
  "login.signingIn": "登入中...",
  "login.hint": "使用透過 ADMIN_EMAIL / ADMIN_PASSWORD 設定的管理員帳戶登入。",

  // Home page
  "home.search": "搜尋影片或標籤",
  "home.noVideosMatch": "沒有符合搜尋的影片",
  "home.noVideosYet": "尚未有影片",
  "home.uploadToStart": "上傳影片以開始。",
  "home.loadFailed": "載入影片失敗：{error}",

  // Upload page
  "upload.title": "上傳影片",
  "upload.noPermission": "你沒有權限上傳影片。請以發佈者或管理員身份登入。",
  "upload.titleLabel": "標題",
  "upload.videoFile": "影片檔案",
  "upload.monetization": "營利方式",
  "upload.requiredTier": "所需等級（可選）",
  "upload.requiredTierPlaceholder": "例如 standard",
  "upload.visibility": "瀏覽權限",
  "upload.visibility.public.desc": "你的租戶中所有人都可以查看和播放此影片",
  "upload.visibility.private.desc": "只有你可以查看和播放此影片",
  "upload.visibility.protected.desc": "只有你和下方選擇的用戶可以查看和播放此影片",
  "upload.grantAccess": "授予存取權限",
  "upload.loadingUsers": "載入用戶中...",
  "upload.selectUser": "請選擇至少一個用戶（或切換為私人）",
  "upload.renditionProfiles": "轉碼設定檔",
  "upload.tags": "標籤（可選）",
  "upload.tagPlaceholder": "輸入標籤後按 Enter",
  "upload.step.details": "詳情",
  "upload.step.upload": "上傳",
  "upload.step.publish": "發佈",
  "upload.step.ready": "就緒",
  "upload.uploading": "上傳中... {percent}%",
  "upload.ingesting": "狀態：{status} — 處理將在背景繼續。完成後此頁面將會更新。",
  "upload.publish": "發佈影片",
  "upload.processing": "處理中...",
  "upload.ready": "你的影片已就緒！",
  "upload.watchNow": "立即觀看",
  "upload.backToHome": "返回主頁",
  "upload.transcodeFailed": "轉碼失敗。請在觀看頁面查看資產的工作詳情。",
  "upload.addTag": "新增標籤",
  "upload.titlesLabel": "標題",
  "upload.file": "個檔案",
  "upload.files": "個檔案",
  "upload.fillAllTitles": "請填寫所有標題。",

  // My Videos page
  "myVideos.title": "我的影片",
  "myVideos.uploadNew": "上傳新影片",
  "myVideos.empty": "你尚未上傳任何影片",
  "myVideos.uploadFirst": "上傳你的第一個影片",
  "myVideos.noPermission": "你沒有權限管理影片。",
  "myVideos.processing": "處理中",
  "myVideos.processingNote": "正在轉碼中",
  "myVideos.published": "已發佈",
  "myVideos.publishedNote": "已上線且可觀看",
  "myVideos.drafts": "草稿（未上傳）",
  "myVideos.draftsNote": "已建立但未上傳原始檔 — 刪除以清理",
  "myVideos.failed": "失敗",
  "myVideos.failedNote": "轉碼失敗 — 刪除以移除損壞的影片",

  // Watch page
  "watch.processing": "排隊處理中...",
  "watch.transcoding": "轉碼進行中...",
  "watch.failed": "此影片處理失敗",
  "watch.processingNote": "此影片仍在處理中。轉碼完成後將自動開始播放。",
  "watch.renditions": "轉碼版本",
  "watch.audioTracks": "音訊聲軌",
  "watch.noAudioTracks": "沒有音訊聲軌",
  "watch.processingJobs": "處理工作",
  "watch.editVisibility": "編輯瀏覽權限",
  "watch.delete": "刪除",
  "watch.channel": "頻道",
  "watch.noTags": "沒有標籤",
  "watch.deleteTitle": "刪除影片",
  "watch.deleteMessage": "你確定要刪除「{title}」嗎？這將永久移除影片及其所有檔案。",
  "watch.editVisibilityTitle": "編輯瀏覽權限",
  "watch.grantAccess": "授予存取權限",
  "watch.attachAudio": "附加音訊",
  "watch.attaching": "附加中...",

  // Users page
  "users.title": "用戶管理",
  "users.onlyAdmin": "只有管理員可以管理用戶。",
  "users.addNew": "新增用戶",
  "users.email": "電郵",
  "users.password": "密碼",
  "users.role": "角色",
  "users.role.viewer": "觀眾",
  "users.role.publisher": "發佈者",
  "users.role.admin": "管理員",
  "users.addUser": "新增用戶",
  "users.users": "用戶（{n}）",
  "users.deleteTitle": "刪除用戶",
  "users.deleteMessage": "你確定要刪除「{email}」嗎？這將移除其帳戶。其上傳的影片將保留，但上傳者連結將被清除。",

  // Titles
  "titles.title": "標題",
  "titles.edit": "編輯",
  "titles.add": "新增",
  "titles.addPlaceholder": "輸入標題",

  // Profile page
  "profile.title": "個人檔案",
  "profile.account": "帳戶",
  "profile.email": "電郵",
  "profile.displayName": "顯示名稱",
  "profile.displayNamePlaceholder": "你的顯示名稱",
  "profile.preferences": "偏好設定",
  "profile.language": "語言",
  "profile.theme": "主題",
  "profile.changePassword": "更改密碼",
  "profile.currentPassword": "目前密碼",
  "profile.newPassword": "新密碼",
  "profile.confirmPassword": "確認新密碼",
  "profile.passwordChanged": "密碼已成功更改。",
  "profile.profileSaved": "個人檔案已儲存。",
  "profile.passwordMismatch": "兩次輸入的新密碼不一致。",
  "profile.passwordTooShort": "新密碼至少需要 6 個字符。",
};

export default zh_HK;
